import { Typography, Grid } from '@mui/material';
import theme from 'assets';

interface IContentProps {
    title: string
    children: React.ReactNode
}

let Content = ({ title, children }: IContentProps) => {

    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="h5">{title}</Typography>
            </Grid>
            <Grid item xs={12} style={{ paddingTop: theme.spacing(1) }}>
                {children}
            </Grid>
        </Grid>
    )
}

export default Content;